import { enNav, krNav } from 'lang/navLang';
import { enCompany, krCompany } from 'lang/companyLang';
import { enProduct, krProduct } from 'lang/productLang';
import { enTechnology, krTechnology } from 'lang/technologyLang';
import { enNotice, krNotice } from 'lang/community/noticeLang';
import { enMain, krMain } from 'lang/mainLang';
import { krInquiry, enInquiry } from 'lang/community/inquiryLang';
import { krQna, enQna, krQnaForm, enQnaForm, enQnaPwd, krQnaPwd } from 'lang/community/qnaLang';
import { krFaq, enFaq } from 'lang/community/faqLang';
import { krArchive, enArchive } from 'lang/community/archiveLang';

import naver from 'assets/images/footer/naver.png';
import facebook from 'assets/images/footer/facebook.png';
import youtube from 'assets/images/footer/youtube.png';

export const logos = [
  { name: 'youtube', link: 'https://www.youtube.com/@farm-in.kr0130', img: youtube },
  // { name: 'facebook', link: 'http://www.facebook.com', img: facebook },
  // { name: 'naver', link: 'http://www.naver.com', img: naver },
];

export const selectLang = [
  { label: 'KO', value: 'kr' },
  { label: 'EN', value: 'en' },
];

export const krLang = {
  nav: krNav,
  main: krMain,
  company: krCompany,
  product: krProduct,
  technology: krTechnology,
  notice: krNotice,
  inquiry: krInquiry,
  faq: krFaq,
  qna: krQna,
  qnaForm: krQnaForm,
  qnaPwd: krQnaPwd,
  archive: krArchive,
  footer: {
    company: `주식회사 팜인`,
    address: `대전광역시 유성구 테크노9로 35 IT벤처타운 407호 (탑립동,아이티전용벤처타운) [우 : 34027]`,
    tel: `042-933-9060`,
    fax: `042-933-9061`,
    email: `farmin0130@farm-in.kr`,
  },
};

export const enLang = {
  nav: enNav,
  main: enMain,
  company: enCompany,
  product: enProduct,
  technology: enTechnology,
  notice: enNotice,
  inquiry: enInquiry,
  faq: enFaq,
  qna: enQna,
  qnaForm: enQnaForm,
  qnaPwd: enQnaPwd,
  archive: enArchive,
  footer: {
    company: `주식회사 팜인_en`,
    address: `대전광역시 유성구 테크노9로 35 IT벤처타운 407호 (탑립동,아이티전용벤처타운) [우 : 34027]`,
    tel: `042-933-9060`,
    fax: `042-933-9061`,
    email: `farmin0130@farm-in.kr`,
  },
};
